module.exports = __webpack_public_path__ + "img/agent-kb-chat.317ec64d.png";